import TablePagination from '../component/TablePagination';
import React, { useEffect, useState } from 'react';
import Layout from '../component/Layout';
import { ArrowUpTrayIcon, EllipsisVerticalIcon, PencilIcon, PlusIcon, TrashIcon } from '@heroicons/react/24/outline';
import { deleteNotification, deleteOrder, findCustomersByBusiness, getCustomers, getNotifications } from '../adapter/api';
import { ApiUrlService } from '../api-library/api-services';
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import './OrderModals.css';
import jsPDF from "jspdf";
import "jspdf-autotable";
import AsyncStorage from '@react-native-async-storage/async-storage';

const ListNotifications = () => {

    const [currentPage, setCurrentPage] = useState(1);
    const rowsPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [isModalAddOpen, setIsModalAddOpen] = useState(false);
    const [selectedCustomer, setSelectedCustomer] = useState(null);
    const [customers, setCustomers] = useState([]);
    const [dropdownOpenId, setDropdownOpenId] = useState(null);
    const [name, setName] = useState(null);
    const [email, setEmail] = useState(null);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [userRole, setUserRole] = useState(null);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [selectedItem, setSelectedItem] = useState(null);
    const toggleDropdown = (id) => setDropdownOpenId(dropdownOpenId === id ? null : id);
    const apiUrlService = new ApiUrlService()
    const handlePageChange = (page) => page > 0 && page <= totalPages && setCurrentPage(page);

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedCustomer(null); // Clear selected order when closing the modal
      };

      

      const cancelDelete = () => {
        setDeleteModal(false);
      };

      const confirmDelete = () => {

        handleDeleteOrder(selectedCustomer);
    
      };


      const handleDeleteOrder = async (order) => {
        try {

          const response = await deleteNotification(order);

          if (response.data.status) {
    
            toast.success("Notifcation Deleted!");
            setDeleteModal(false)
            handleGetCustomers()
    
    
          }
        } catch (error) {
          toast.error("Error deleting item!");
          console.error("Delete error:", error);
        }
      }
    


    // Inside the component function
    const exportToPDF = () => {
        const doc = new jsPDF();

        // Adding title to PDF
        doc.text("Notifications", 20, 20);

        // Set up headers for the table
        const headers = ["Title", "Description", "Date"];

        // Create rows dynamically based on orders
        const rows = paginatedOrders.map(order => [

            order.title,
            order.description,
            order.date
        ]);

        // Add the table to the PDF
        doc.autoTable({
            head: [headers],
            body: rows,
            startY: 30, // The Y position where the table starts
        });

        // Save the PDF to the local system
        doc.save("notifications.pdf");
    };


    const formatDate = (value) => {
      const date = new Date(value);
    
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-indexed
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2,'0')
    
      return `${year}-${month}-${day}    ${hours}:${minutes}:${seconds}`;
    };

    // Derived states
    const filteredOrders = customers.filter((order) => {
        const search = searchTerm.toLowerCase();
        return (
            order.title?.toString().toLowerCase().includes(search) ||
            order.description?.toLowerCase().includes(search) ||
            formatDate(order.date).toLowerCase().includes(search)
        );
    });

    const totalPages = Math.ceil(filteredOrders.length / rowsPerPage);
  useEffect(() => {
    setCurrentPage(page => Math.min(page, Math.max(1, totalPages)));
  }, [totalPages]);
    const paginatedOrders = filteredOrders.slice(
        (currentPage - 1) * rowsPerPage,
        currentPage * rowsPerPage
    );

    const handleSearchChange = (e) => {
      setSearchTerm(e.target.value);
      setCurrentPage(1); // Reset to first page on search
    };
    const openModal = (order) => {
        toggleDropdown(null)
        setSelectedCustomer(order); // Set the selected order to display its details
        setIsModalOpen(true);
      };

      const openDeleteModal = (order) => {
        toggleDropdown(null)
        setSelectedCustomer(order.notificationId); // Set the selected order to display its details
        setDeleteModal(true);
      };


      
    const handleGetCustomers = async () => {
        setCustomers([]);


        try {

            const response = await getNotifications()
            setCustomers(response.data.data)


        } catch (error) {
            console.error("Error fetching user role:", error);
        } finally {

        }

    }


    useEffect(() => {
        handleGetCustomers()
    }, []);




    return (
        <Layout>
            <ToastContainer />
            <h1 className="text-2xl font-medium mb-4 mt-7 font-inter text-lg">Notifications</h1>
            {/* Page content goes here */}
            <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

            <div className="data-card overflow-x-auto mt-4 rounded-lg">
                <div className="data-toolbar bg-grey flex justify-between items-center mb-0 w-full border-t border-l pl-3 border-r pr-3 pt-3 border-gray-200">

                    <div className="w-1/3 pb-3">
                        <input
                            type="text"
                            value={searchTerm}
                            onChange={handleSearchChange}
                            placeholder="Search notifications…" aria-label="Search notifications"
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                        />
                    </div>

                    <div className="npb-3 flex">

                        <button onClick={exportToPDF}
                            className="px-4 py-2 bg-yellow flex text-white font-inter text-sm font-sm rounded-lg hover:bg-customColor transition-colors"
                        > <ArrowUpTrayIcon className="h-4 w-4 mr-2 mt-0.4" />
                            Export
                        </button>
                    </div>
                </div>
                <table className="data-table  min-w-full bg-white border-b border-r border-l border-gray-200 shadow-sm">
                    <thead>
                        <tr className="bg-grey border-b">
                        <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700"></th>
                            <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Title</th>
                            <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Description</th>
                            <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Date</th>
                            <th className="px-4 py-3 font-inter text-left text-sm font-semibold text-gray-700">Customer</th>
                        </tr>
                    </thead>
                    <tbody>
                        {paginatedOrders.map((order) => (
                            
                            <tr
                                key={order.notificationId}
                                className="border-b hover:bg-gray-50"
                            >
                                <td
                  className="px-4 py-3 text-sm text-yellow font-inter cursor-pointer"

                >
                  <EllipsisVerticalIcon className="h-5 w-5 mr-2"
                    onClick={() => toggleDropdown(order.notificationId)} />
                  {dropdownOpenId === order.notificationId && (
                    <div className="absolute bg-white shadow rounded p-2" style={{ width: "10%" }}>
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openModal(order)}>View</button>
                      <button className="block w-full text-left px-2 py-1 hover:text-yellow text-gray-700" onClick={() => openDeleteModal(order)}>Delete</button>
                    </div>
                  )}
                </td>
                                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.title}</td>
                                <td
                                    className="px-4 py-3 text-sm text-gray-700 font-inter font-medium truncate max-w-xs"
                                    title={order.description} // Show full text on hover
                                >
                                    {order.description}
                                </td>
                                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{formatDate(order.date)}</td>
                                <td className="px-4 py-3 text-sm text-gray-700 font-inter font-medium">{order.customer ?  order.customer.firstName : "For All"}</td>
                            </tr>
                        ))}

                    </tbody>
                </table>
                {/* Pagination */}
                <div className="data-pagination bg-grey mb-0 w-full flex justify-between border-t border-l pl-3 border-r pr-3 pt-3 items-center md:flex-row justify-between pt-4">
                    <span className="text-sm font-medium">
                        Showing {filteredOrders.length ? (currentPage - 1) * rowsPerPage + 1 : 0}-{Math.min(currentPage * rowsPerPage, filteredOrders.length)} of{' '}
                        {filteredOrders.length}
                    </span>
                    <TablePagination currentPage={currentPage} totalPages={totalPages} onPageChange={handlePageChange} />
                </div>
            </div>
            <div className="data-endcap">

            {isModalOpen && selectedCustomer && (
          <div className="order-modal-backdrop fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
            <div className="order-modal-panel bg-white rounded-lg shadow-lg p-6">
              <h2 className="text-lg font-semibold mb-4">Notification Details</h2>
              <hr className="w-full" style={{ border: "1px solid var(--color-border)", margin: "10px 0" }} />

              {/* Other Order Details */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Title</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={selectedCustomer.title}
                />

                <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
                <textarea
                className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                rows="3"
                defaultValue={selectedCustomer.description}
              ></textarea>

                <label className="block text-sm font-medium text-gray-700 mb-1">Date</label>
                <input
                  type="text"
                  className="w-full px-3 py-2 border border-gray-300 rounded-lg mb-4"
                  value={formatDate(selectedCustomer.date)}
                />

             

              </div>





              <div className="flex justify-center space-x-2">
              
                <button className="px-5 py-1 bg-white font-inter  border border-gray-700 text-gray-700 text-sm  rounded-lg hover:bg-yellow hover:text-white hover:border-white"
                  onClick={closeModal}>
                  CANCEL
                </button>
              </div>
            </div>
          </div>
        )}

{deleteModal && (
          <div className="order-modal-backdrop fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="order-dialog-panel bg-white p-6 rounded-lg shadow-lg">
              <p className="text-lg font-semibold mb-4">
                Are you sure you want to delete this notification?
              </p>
              <div className="flex justify-end space-x-4">
                <button
                  className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow "
                  onClick={cancelDelete}
                >
                  No
                </button>
                <button
                  className="px-4 py-2 bg-gray-400 rounded hover:bg-yellow"
                  onClick={confirmDelete}
                >
                  Yes
                </button>
              </div>
            </div>
          </div>
        )}





            </div>
        </Layout>
    );
};

export default ListNotifications;
